import { LodgingSelectionEnum, MegaMenuRootNode, NonEmptyArray } from "redmond";

export const ACTION_BASED_MEGA_MENU_ROOT_NODES: NonEmptyArray<MegaMenuRootNode> =
  [
    {
      label: "Beach escapes",
      imageUrl: "",
      sections: [
        {
          subsections: [
            {
              label: "Mexican resorts",
              leafNodes: [
                {
                  label: "Cancún",
                  lodgingSelection: {
                    placeId: "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
                    searchTerm: "Cancún, Quintana Roo, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cabo San Lucas",
                  lodgingSelection: {
                    placeId: "ChIJoQjlifNKr4YRaLiiwWLfpEs",
                    searchTerm: "Cabo San Lucas, BCS, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Puerto Vallarta",
                  lodgingSelection: {
                    placeId: "ChIJf8hjUGNFIYQRdFK_hZm_z3k",
                    searchTerm: "Puerto Vallarta, Jalisco, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santa María Huatulco",
                  lodgingSelection: {
                    placeId: "ChIJ6VMgy38uv4URRVgPTmippsg",
                    searchTerm: "Santa María Huatulco, Oaxaca, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Ciudad del Carmen",
                  lodgingSelection: {
                    placeId: "ChIJxe8nVwkH8YURxZF2aTCRX50",
                    searchTerm: "Ciudad del Carmen, Campeche, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tulum",
                  lodgingSelection: {
                    placeId: "ChIJSyrkEAPUT48Rt5r_k9vA7Q4",
                    searchTerm: "Tulum, Quintana Roo, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Caribbean island escapes",
              leafNodes: [
                {
                  label: "Punta Cana",
                  lodgingSelection: {
                    placeId: "ChIJd_7LXWSRqI4R8_YS7fociGE",
                    searchTerm: "Punta Cana, Dominican Republic",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Aruba",
                  lodgingSelection: {
                    placeId: "ChIJN4q-Qds4hY4Ro2I-jCDbM00",
                    searchTerm: "Oranjestad, Aruba",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Nassau",
                  lodgingSelection: {
                    placeId: "ChIJyduBuZl8L4kR0lBeSNMB7yo",
                    searchTerm: "Nassau, The Bahamas",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Montego Bay",
                  lodgingSelection: {
                    placeId: "ChIJseJ3_V0q2o4RZlfMWtua1vw",
                    searchTerm: "Montego Bay, Jamaica",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Juan",
                  lodgingSelection: {
                    placeId: "ChIJbxlo4m9oA4wR3FqTXA9_a60",
                    searchTerm: "San Juan, Puerto Rico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Turks and Caicos Islands",
                  lodgingSelection: {
                    placeId: "ChIJA-9GbMlIS4kRvLmSdgOXigQ",
                    searchTerm: "Providenciales, Turks and Caicos Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Grand Cayman",
                  lodgingSelection: {
                    placeId: "ChIJYSlB53KHJY8RY3eEpVLPpq4",
                    searchTerm: "Seven Mile Beach, Cayman Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "U.S. Virgin Islands",
                  lodgingSelection: {
                    placeId: "ChIJtzUG3IkaBYwR5Jf28eeAEl0",
                    searchTerm: "Saint Thomas, St. Thomas, U.S. Virgin Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Hawaii & Pacific islands",
              leafNodes: [
                {
                  label: "Oahu",
                  lodgingSelection: {
                    placeId: "ChIJA2ty2zJmAHwRw8tvkGl9WNk",
                    searchTerm: "Oahu, Hawaii, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Maui",
                  lodgingSelection: {
                    placeId: "ChIJ-endi8cqVXkRbpYfLncR5rI",
                    searchTerm: "Lahaina, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kauai",
                  lodgingSelection: {
                    placeId: "ChIJN7YiXoAeB3wRSCJF9-ghCfU",
                    searchTerm: "Lihue, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Island of Hawai'i",
                  lodgingSelection: {
                    placeId: "ChIJAbSRarIOVHkRp6UtiIMdkQc",
                    searchTerm: "Kailua-Kona, HI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bora-Bora",
                  lodgingSelection: {
                    placeId: "ChIJK6Wf3FO8vXYRWcWLFrt275s",
                    searchTerm: "Bora-Bora, French Polynesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Guam",
                  lodgingSelection: {
                    placeId: "ChIJa-UgfgV4H2cRTJ8Vq2FpPwk",
                    searchTerm: "Tamuning, Guam",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Domestic beach escapes",
              leafNodes: [
                {
                  label: "Key West",
                  lodgingSelection: {
                    placeId: "ChIJdyOVrTSx0YgRXjtGdy_pzj8",
                    searchTerm: "Key West, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "St. Petersburg",
                  lodgingSelection: {
                    placeId: "ChIJQao6aWPmwogR_4vUvANAzAQ",
                    searchTerm: "St. Petersburg, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Naples",
                  lodgingSelection: {
                    placeId: "ChIJrdfCc5vh2ogRqpos1xhTP2c",
                    searchTerm: "Naples, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cape Cod",
                  lodgingSelection: {
                    placeId: "ChIJVR-faLox-4kRc60mW7VAROY",
                    searchTerm: "Hyannis, Barnstable, MA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Outer Banks",
                  lodgingSelection: {
                    placeId: "ChIJcWxzpzxbpIkRszbSdWERdxs",
                    searchTerm:
                      "Outer Banks, North Carolina, United States of America",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Myrtle Beach",
                  lodgingSelection: {
                    placeId: "ChIJASFVO5VoAIkRGJbQtRWxD7w",
                    searchTerm: "Myrtle Beach, SC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sarasota",
                  lodgingSelection: {
                    placeId: "ChIJK8KyneY3w4gR2RVXHR00NeM",
                    searchTerm: "Sarasota, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Gulf Shores",
                  lodgingSelection: {
                    placeId: "ChIJTe4xktgamogRb9H2dVBxusY",
                    searchTerm: "Gulf Shores, AL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "South Padre Island",
                  lodgingSelection: {
                    placeId: "ChIJ761vtJupb4YRIrPbw1yyW00",
                    searchTerm: "South Padre Island, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Galveston",
                  lodgingSelection: {
                    placeId: "ChIJWZIFxMhZP4YRwezquckDi-U",
                    searchTerm: "Galveston, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "European summer favorites",
              leafNodes: [
                {
                  label: "Palma de Mallorca",
                  lodgingSelection: {
                    placeId: "ChIJV8caxlmSlxIRxljQwwZUDcQ",
                    searchTerm: "Palma, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Fira",
                  lodgingSelection: {
                    placeId: "ChIJ6bzjBc7NmRQR26Hvu5LB9Ak",
                    searchTerm: "Santorini, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Nice",
                  lodgingSelection: {
                    placeId: "ChIJMS2FahDQzRIRcJqX_aUZCAQ",
                    searchTerm: "Nice, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Ibiza",
                  lodgingSelection: {
                    placeId: "ChIJhRmdbbxGmRIRiPpXk_IayrY",
                    searchTerm: "Ibiza, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Split",
                  lodgingSelection: {
                    placeId: "ChIJF_W8a_xdNRMRmJ-0MfaPeaE",
                    searchTerm: "Split, Croatia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Dubrovnik",
                  lodgingSelection: {
                    placeId: "ChIJfeg1CKKLSxMRANUrhlCtAAQ",
                    searchTerm: "Dubrovnik, Croatia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Mykonos",
                  lodgingSelection: {
                    placeId: "ChIJkZs88LS4ohQRobR5Hkdk0Xg",
                    searchTerm: "Mykonos, Mikonos, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sicily",
                  lodgingSelection: {
                    placeId: "ChIJmdBOgcnoGRMRgNg7IywECwo",
                    searchTerm: "Palermo, PA, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Lake Como",
                  lodgingSelection: {
                    placeId: "ChIJY-0nEEichkcRJPVfeK-Wm7k",
                    searchTerm: "Como, Province of Como, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Honeymoon favorites",
              leafNodes: [
                {
                  label: "Amalfi Coast",
                  lodgingSelection: {
                    placeId: "ChIJ0cUhSbWVOxMRqayyn5ksGhU",
                    searchTerm: "Amalfi, SA, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Turks and Caicos Islands",
                  lodgingSelection: {
                    placeId: "ChIJA-9GbMlIS4kRvLmSdgOXigQ",
                    searchTerm: "Providenciales, Turks and Caicos Islands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Maldives",
                  lodgingSelection: {
                    placeId: "ChIJZWQCGugnQDsRD7-h_VRlpOQ",
                    searchTerm: "Baa Atoll, Maldives",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Seychelles",
                  lodgingSelection: {
                    placeId: "ChIJGTqSulMq4CIRLOIygZTdY0M",
                    searchTerm: "Mahé, Seychelles",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Fiji",
                  lodgingSelection: {
                    placeId: "ChIJh0HZyeIxGm4RBdEfAdcwKlA",
                    searchTerm: "Pacific Harbour, Fiji",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Saint Lucia",
                  lodgingSelection: {
                    placeId: "ChIJITxCH4VCQIwRqirCF5alth4",
                    searchTerm: "Gros Islet, Saint Lucia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santorini",
                  lodgingSelection: {
                    placeId: "ChIJ6bzjBc7NmRQR26Hvu5LB9Ak",
                    searchTerm: "Santorini, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tahiti",
                  lodgingSelection: {
                    placeId: "ChIJZR4tmFOzm3YR-qOIiTr0PEE",
                    searchTerm: "Tahiti, French Polynesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Asia beach favorites",
              leafNodes: [
                {
                  label: "Bali",
                  lodgingSelection: {
                    placeId: "ChIJN3P2zJlG0i0RACx9yvsLAwQ",
                    searchTerm: "Kuta, Badung Regency, Bali, Indonesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Phuket",
                  lodgingSelection: {
                    placeId: "ChIJT1JixOIxUDARIbo9BoWayuk",
                    searchTerm: "Phuket, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Koh Samui",
                  lodgingSelection: {
                    placeId: "ChIJcyZmHFDxVDAR0IA2LLwjAgM",
                    searchTerm:
                      "Koh Samui, Ko Samui District, Surat Thani, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Boracay",
                  lodgingSelection: {
                    placeId: "ChIJV1KXxSU9pTMRISAzQr8ajlI",
                    searchTerm: "Boracay Island, Malay, Aklan, Philippines",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Palawan",
                  lodgingSelection: {
                    placeId: "ChIJpdYJytBjtTMRjW9JV1d5yZA",
                    searchTerm: "Puerto Princesa City, Palawan, Philippines",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Krabi",
                  lodgingSelection: {
                    placeId: "ChIJBy8kHpmUUTARV5vJ1-QTjnQ",
                    searchTerm:
                      "Krabi, Pak Nam, Mueang Krabi District, Krabi, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Da Nang",
                  lodgingSelection: {
                    placeId: "ChIJEyolkscZQjERBn5yhkvL8B0",
                    searchTerm: "Da Nang, Vietnam",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Jeju Island",
                  lodgingSelection: {
                    placeId: "ChIJtcMT0y1pDDURs0J4dM6N51I",
                    searchTerm: "Cheju, Jeju-do, South Korea",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Okinawa",
                  lodgingSelection: {
                    placeId: "ChIJhctD7_EE5TQRT3Dlw7MusTI",
                    searchTerm: "Onna, Okinawa, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cebu City",
                  lodgingSelection: {
                    placeId: "ChIJ_S3NjSWZqTMRBzXT2wwDNEw",
                    searchTerm: "Cebu, Philippines",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Koh Phi Phi",
                  lodgingSelection: {
                    placeId: "ChIJDT1Odr4gTjARcZ9UGni4nb8",
                    searchTerm:
                      "Ko Phi Phi, Mueang Krabi District, Krabi, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "City breaks",
      imageUrl: "",
      sections: [
        {
          subsections: [
            {
              label: "US metropolises",
              leafNodes: [
                {
                  label: "New York",
                  lodgingSelection: {
                    placeId: "ChIJOwg_06VPwokRYv534QaPC8g",
                    searchTerm: "New York, NY, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Los Angeles",
                  lodgingSelection: {
                    placeId: "ChIJE9on3F3HwoAR9AhGJW_fL-I",
                    searchTerm: "Los Angeles, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Chicago",
                  lodgingSelection: {
                    placeId: "ChIJ7cv00DwsDogRAMDACa2m4K8",
                    searchTerm: "Chicago, IL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Houston",
                  lodgingSelection: {
                    placeId: "ChIJAYWNSLS4QIYROwVl894CDco",
                    searchTerm: "Houston, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Miami",
                  lodgingSelection: {
                    placeId: "ChIJEcHIDqKw2YgRZU-t3XHylv8",
                    searchTerm: "Miami, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Dallas",
                  lodgingSelection: {
                    placeId: "ChIJS5dFe_cZTIYRj2dH9qSb7Lk",
                    searchTerm: "Dallas, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Philadelphia",
                  lodgingSelection: {
                    placeId: "ChIJ60u11Ni3xokRwVg-jNgU9Yk",
                    searchTerm: "Philadelphia, PA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Washington",
                  lodgingSelection: {
                    placeId: "ChIJW-T2Wt7Gt4kRKl2I1CJFUsI",
                    searchTerm: "Washington D.C., DC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Atlanta",
                  lodgingSelection: {
                    placeId: "ChIJjQmTaV0E9YgRC2MLmS_e_mY",
                    searchTerm: "Atlanta, GA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Boston",
                  lodgingSelection: {
                    placeId: "ChIJGzE9DS1l44kRoOhiASS_fHg",
                    searchTerm: "Boston, MA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Phoenix",
                  lodgingSelection: {
                    placeId: "ChIJy3mhUO0SK4cRrBtKNfjHaYw",
                    searchTerm: "Phoenix, AZ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Detroit",
                  lodgingSelection: {
                    placeId: "ChIJdR3LEAHKJIgR0sS5NU6Gdlc",
                    searchTerm: "Detroit, MI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Seattle",
                  lodgingSelection: {
                    placeId: "ChIJVTPokywQkFQRmtVEaUZlJRA",
                    searchTerm: "Seattle, WA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Francisco",
                  lodgingSelection: {
                    placeId: "ChIJIQBpAG2ahYAR_6128GcTUEo",
                    searchTerm: "San Francisco, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "US mountain towns",
              leafNodes: [
                {
                  label: "Asheville",
                  lodgingSelection: {
                    placeId: "ChIJCW8PPKmMWYgRXTo0BsEx75Q",
                    searchTerm: "Asheville, NC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sedona",
                  lodgingSelection: {
                    placeId: "ChIJDbBC-TKhLYcR_Y5s-iPFSFU",
                    searchTerm: "Sedona, AZ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Boulder",
                  lodgingSelection: {
                    placeId: "ChIJ06-NJ06Na4cRWIAboHw7Ocg",
                    searchTerm: "Boulder, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bozeman",
                  lodgingSelection: {
                    placeId: "ChIJE4i6T0xERVMRqmA792TQ9WM",
                    searchTerm: "Bozeman, MT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bend",
                  lodgingSelection: {
                    placeId: "ChIJUdLTpf_AuFQRtNEgx6zniBA",
                    searchTerm: "Bend, OR, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santa Fe",
                  lodgingSelection: {
                    placeId: "ChIJqVKY50NQGIcRQN-I_XMjkIw",
                    searchTerm: "Santa Fe, NM, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Whitefish",
                  lodgingSelection: {
                    placeId: "ChIJR8LqnJVQZlMRYrtaHdq9H68",
                    searchTerm: "Kalispell, MT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Durango",
                  lodgingSelection: {
                    placeId: "ChIJI_yFvaYCPIcRWn6mo4KIK9w",
                    searchTerm: "Durango, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Flagstaff",
                  lodgingSelection: {
                    placeId: "ChIJMSYu2veOLYcRALPbzqE8H44",
                    searchTerm: "Flagstaff, AZ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Taos",
                  lodgingSelection: {
                    placeId: "ChIJsfwRf9pkF4cRgrepYYOR6pA",
                    searchTerm: "Taos, NM, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "US coastal towns",
              leafNodes: [
                {
                  label: "Charleston",
                  lodgingSelection: {
                    placeId: "ChIJdySo3EJ6_ogRa-zhruD3-jU",
                    searchTerm: "Charleston, SC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Savannah",
                  lodgingSelection: {
                    placeId: "ChIJWQbyePx1-4gRvCBgA1FnDE4",
                    searchTerm: "Savannah, GA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bar Harbor",
                  lodgingSelection: {
                    placeId: "ChIJkyWAFUi-rkwRG9nKKGUa6Yg",
                    searchTerm: "Bar Harbor, ME, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Newport",
                  lodgingSelection: {
                    placeId: "ChIJa5cJBbe65YkRIW8vLPeWXs4",
                    searchTerm: "Newport, RI, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santa Barbara",
                  lodgingSelection: {
                    placeId: "ChIJ1YMtb8cU6YARSHa612Q60cg",
                    searchTerm: "Santa Barbara, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Monterey",
                  lodgingSelection: {
                    placeId: "ChIJkfu1cFLkjYARXj1K2AlJSO4",
                    searchTerm: "Monterey, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Nantucket",
                  lodgingSelection: {
                    placeId: "ChIJa2reu3vc-okRTcifBPmRozM",
                    searchTerm: "Nantucket, MA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Portland",
                  lodgingSelection: {
                    placeId: "ChIJLe6wqnKcskwRKfpyM7W2nX4",
                    searchTerm: "Portland, ME, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "St. Augustine",
                  lodgingSelection: {
                    placeId: "ChIJT3_fdVeC5ogRJ2AnixeDocI",
                    searchTerm: "St. Augustine, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cape May",
                  lodgingSelection: {
                    placeId: "ChIJlffuOkRUv4kRovRz4Zz3t8I",
                    searchTerm: "Cape May, NJ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hilton Head Island",
                  lodgingSelection: {
                    placeId: "ChIJrRnTjtx5_IgRPSii63qm5Sw",
                    searchTerm: "Hilton Head Island, SC, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Luis Obispo",
                  lodgingSelection: {
                    placeId: "ChIJJ8Jse77m7IARRg_vzsKQArw",
                    searchTerm: "San Luis Obispo, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Canada",
              leafNodes: [
                {
                  label: "Toronto",
                  lodgingSelection: {
                    placeId: "ChIJpTvG15DL1IkRd8S0KlBVNTI",
                    searchTerm: "Toronto, ON, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Vancouver",
                  lodgingSelection: {
                    placeId: "ChIJs0-pQ_FzhlQRi_OBm-qWkbs",
                    searchTerm: "Vancouver, BC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Montreal",
                  lodgingSelection: {
                    placeId: "ChIJDbdkHFQayUwR7-8fITgxTmU",
                    searchTerm: "Montreal, QC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Calgary",
                  lodgingSelection: {
                    placeId: "ChIJ1T-EnwNwcVMROrZStrE7bSY",
                    searchTerm: "Calgary, AB, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Québec City",
                  lodgingSelection: {
                    placeId: "ChIJk4jbBYqWuEwRAzro8GMtxY8",
                    searchTerm: "Québec, QC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Latin America",
              leafNodes: [
                {
                  label: "Mexico City",
                  lodgingSelection: {
                    placeId: "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
                    searchTerm: "Mexico City, CDMX, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Panama City",
                  lodgingSelection: {
                    placeId: "ChIJYwPo2_GorI8RDsFC8PFdoqs",
                    searchTerm: "Panama City, Panama",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Medellín",
                  lodgingSelection: {
                    placeId: "ChIJBa0PuN8oRI4RVju1x_x8E0I",
                    searchTerm: "Medellín, Medellin, Antioquia, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Buenos Aires",
                  lodgingSelection: {
                    placeId: "ChIJvQz5TjvKvJURh47oiC6Bs6A",
                    searchTerm: "Buenos Aires, Argentina",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bogotá",
                  lodgingSelection: {
                    placeId: "ChIJKcumLf2bP44RFDmjIFVjnSM",
                    searchTerm: "Bogotá, Bogota, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "São Paulo",
                  lodgingSelection: {
                    placeId: "ChIJ0WGkg4FEzpQRrlsz_whLqZs",
                    searchTerm: "São Paulo, State of São Paulo, Brazil",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rio de Janeiro",
                  lodgingSelection: {
                    placeId: "ChIJW6AIkVXemwARTtIvZ2xC3FA",
                    searchTerm:
                      "Rio de Janeiro, State of Rio de Janeiro, Brazil",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cartagena",
                  lodgingSelection: {
                    placeId: "ChIJUROdrucl9o4RyiY_Ay45YbE",
                    searchTerm:
                      "Cartagena, Cartagena Province, Bolivar, Colombia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Lima",
                  lodgingSelection: {
                    placeId: "ChIJxz7uGfbFBZERSi5FzLlsIBQ",
                    searchTerm: "Lima, Peru",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Santiago",
                  lodgingSelection: {
                    placeId: "ChIJL68lBEHFYpYRMQkPQDzVdYQ",
                    searchTerm: "Santiago, Chile",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Asian megacities",
              leafNodes: [
                {
                  label: "Tokyo",
                  lodgingSelection: {
                    placeId: "ChIJC3Cf2PuLGGAROO00ukl8JwA",
                    searchTerm:
                      "Tokyo Station, 1 Chome-9 Marunouchi, Chiyoda City, Tokyo, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Seoul",
                  lodgingSelection: {
                    placeId: "ChIJzzlcLQGifDURm_JbQKHsEX4",
                    searchTerm: "Seoul, South Korea",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bangkok",
                  lodgingSelection: {
                    placeId: "ChIJ82ENKDJgHTERIEjiXbIAAQE",
                    searchTerm: "Bangkok, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Singapore",
                  lodgingSelection: {
                    placeId: "ChIJdZOLiiMR2jERxPWrUs9peIg",
                    searchTerm: "Singapore",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hong Kong",
                  lodgingSelection: {
                    placeId: "ChIJY08J76z4AzQRxALvQEcjed8",
                    searchTerm: "Kowloon, Hong Kong",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Shanghai",
                  lodgingSelection: {
                    placeId: "ChIJMzz1sUBwsjURoWTDI5QSlQI",
                    searchTerm: "Shanghai, China",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Beijing",
                  lodgingSelection: {
                    placeId: "ChIJuSwU55ZS8DURiqkPryBWYrk",
                    searchTerm: "Beijing, China",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "European capitals",
              leafNodes: [
                {
                  label: "London",
                  lodgingSelection: {
                    placeId: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                    searchTerm: "London, UK",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Paris",
                  lodgingSelection: {
                    placeId: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                    searchTerm: "Paris, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rome",
                  lodgingSelection: {
                    placeId: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
                    searchTerm:
                      "Rome, Metropolitan City of Rome Capital, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Amsterdam",
                  lodgingSelection: {
                    placeId: "ChIJVXealLU_xkcRja_At0z9AGY",
                    searchTerm: "Amsterdam, Netherlands",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Barcelona",
                  lodgingSelection: {
                    placeId: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
                    searchTerm: "Barcelona, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Vienna",
                  lodgingSelection: {
                    placeId: "ChIJn8o2UZ4HbUcRRluiUYrlwv0",
                    searchTerm: "Vienna, Austria",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Prague",
                  lodgingSelection: {
                    placeId: "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
                    searchTerm: "Prague, Czechia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Budapest",
                  lodgingSelection: {
                    placeId: "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
                    searchTerm: "Budapest, Hungary",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Lisbon",
                  lodgingSelection: {
                    placeId: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
                    searchTerm: "Lisbon, Portugal",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Outdoor adventures",
      imageUrl: "",
      sections: [
        {
          subsections: [
            {
              label: "North America winter sports & hiking",
              leafNodes: [
                {
                  label: "Breckenridge",
                  lodgingSelection: {
                    placeId: "ChIJwecmbD32aocReqKAZn-PjWI",
                    searchTerm: "Breckenridge, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Burlington",
                  lodgingSelection: {
                    placeId: "ChIJ5VWbtlV6ykwRjkkOchnlX8M",
                    searchTerm: "Burlington, VT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Jackson Hole",
                  lodgingSelection: {
                    placeId: "ChIJS3_P_FgaU1MRXIM6scsBHD0",
                    searchTerm: "Jackson Hole, WY, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "South Lake Tahoe",
                  lodgingSelection: {
                    placeId: "ChIJ4U-l7omFmYARjpEj-0YvG90",
                    searchTerm: "South Lake Tahoe, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Mammoth Lakes",
                  lodgingSelection: {
                    placeId: "ChIJnxezeV8MloARbY3uD9fZFPE",
                    searchTerm: "Mammoth Lakes, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Park City",
                  lodgingSelection: {
                    placeId: "ChIJ_QNjLGMPUocRlFc3Jd_Ecdg",
                    searchTerm: "Park City, UT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sun Valley",
                  lodgingSelection: {
                    placeId: "ChIJEy5RHN-CqVQRUCy0ZiNqDAc",
                    searchTerm: "Sun Valley, ID, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Telluride",
                  lodgingSelection: {
                    placeId: "ChIJc_TmcHvYPocR4eO6cSF37jg",
                    searchTerm: "Telluride, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Vail",
                  lodgingSelection: {
                    placeId: "ChIJB89dUQVwaocRxKOafh_AzMk",
                    searchTerm: "Vail, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Aspen",
                  lodgingSelection: {
                    placeId: "ChIJfTxB93w5QIcRcvYseNxCK8E",
                    searchTerm: "Aspen, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Whistler",
                  lodgingSelection: {
                    placeId: "ChIJh3uVA7I8h1QR9s_1dehBt0o",
                    searchTerm: "Whistler, BC, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Overseas winter sports & hiking",
              leafNodes: [
                {
                  label: "Chamonix",
                  lodgingSelection: {
                    placeId: "ChIJ5y7-LQZMiUcRgKO65CqrCAQ",
                    searchTerm: "Chamonix, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Innsbruck",
                  lodgingSelection: {
                    placeId: "ChIJc8r44c9unUcRDZsdKH0cIJ0",
                    searchTerm: "Innsbruck, Austria",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Niseko",
                  lodgingSelection: {
                    placeId: "ChIJo1x_xZGuCl8RrJLxQh149XE",
                    searchTerm: "Niseko, Hokkaido, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Zermatt",
                  lodgingSelection: {
                    placeId: "ChIJzeUuKaI1j0cRcG8ZQIj_AAQ",
                    searchTerm: "Zermatt, Switzerland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Verbier",
                  lodgingSelection: {
                    placeId: "ChIJc6mm987PjkcRkYgnDZw-3v8",
                    searchTerm: "Verbier, Val de Bagnes, Switzerland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "St. Anton am Arlberg",
                  lodgingSelection: {
                    placeId: "ChIJBZ5afmCwnEcRj60i3GNGyZE",
                    searchTerm: "St Anton am Arlberg, Austria",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cortina d'Ampezzo",
                  lodgingSelection: {
                    placeId: "ChIJPwNH0jU0eEcRK-SSe0MwPN0",
                    searchTerm: "Cortina d'Ampezzo, Province of Belluno, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hakuba Valley",
                  lodgingSelection: {
                    placeId: "ChIJ5_6hSuPR918REzUb61r1JNA",
                    searchTerm: "Hakuba, Nagano, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Queenstown",
                  lodgingSelection: {
                    placeId: "ChIJX96o1_Ed1akRAKZ5hIbvAAU",
                    searchTerm: "Queenstown, New Zealand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Garmisch-Partenkirchen",
                  lodgingSelection: {
                    placeId: "ChIJKTOKk2ABnUcRgJyL161IHgQ",
                    searchTerm: "Garmisch-Partenkirchen, Germany",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Val d'Isère",
                  lodgingSelection: {
                    placeId: "ChIJk_tf_QkJiUcRMKi65CqrCAQ",
                    searchTerm: "Val-d'Isère, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Les 3 Vallées",
                  lodgingSelection: {
                    placeId: "ChIJM75gB_cqikcRlfFzQ20Y-TY",
                    searchTerm: "Les 3 Vallées, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kitzbuhel",
                  lodgingSelection: {
                    placeId: "ChIJFV1O4HVNdkcRWkupS_2Xtv8",
                    searchTerm: "Kitzbuhel, Austria",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "North America national parks",
              leafNodes: [
                {
                  label: "Acadia National Park",
                  lodgingSelection: {
                    placeId: "ChIJJSmiDrKjrkwRhFVV_A4i32I",
                    searchTerm: "Acadia National Park, Maine, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Arches National Park",
                  lodgingSelection: {
                    placeId: "ChIJUaoNhhr2yoARlcQo0WnqQk8",
                    searchTerm: "Arches National Park, Utah, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bryce Canyon National Park",
                  lodgingSelection: {
                    placeId: "ChIJbUw47h9pNYcRYv1Jemw3nHU",
                    searchTerm: "Bryce Canyon City, UT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Death Valley National Park",
                  lodgingSelection: {
                    placeId: "ChIJc131Vgc_x4ARNuhbu-BiSC0",
                    searchTerm: "Furnace Creek, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Glacier National Park",
                  lodgingSelection: {
                    placeId: "ChIJVVVVVRWQaFMR7F3FFSK8Fq8",
                    searchTerm: "Glacier National Park, Montana, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Grand Canyon National Park",
                  lodgingSelection: {
                    placeId: "ChIJjeAnvVQGzIARjS7UQkRVwrE",
                    searchTerm: "Grand Canyon, Arizona, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Grand Teton National Park",
                  lodgingSelection: {
                    placeId: "ChIJqRtdyZ5RUlMRN6ORzI64oKU",
                    searchTerm: "Grand Teton National Park, Wyoming, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Joshua Tree National Park",
                  lodgingSelection: {
                    placeId: "ChIJz35ewibH2oAR_KNjyULrN-w",
                    searchTerm: "Twentynine Palms, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Olympic National Park",
                  lodgingSelection: {
                    placeId: "ChIJR-fnwAxSjlQR2aVPY4xhvF0",
                    searchTerm: "Port Angeles, WA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rocky Mountain National Park",
                  lodgingSelection: {
                    placeId: "ChIJ6QNZReR5aYcRF4KOp0PuJ_o",
                    searchTerm: "Boulder, CO, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sequoia National Park",
                  lodgingSelection: {
                    placeId: "ChIJObTlVoBPlYAR-0rOmqnypg4",
                    searchTerm: "Three Rivers, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Yellowstone National Park",
                  lodgingSelection: {
                    placeId: "ChIJxbVfgaQfTlMRa-n8WQ9rYlU",
                    searchTerm: "Yellowstone National Park, WY, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Yosemite National Park",
                  lodgingSelection: {
                    placeId: "ChIJ5UQwu0frloARzlhenukj9zQ",
                    searchTerm: "Yosemite West, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Zion National Park",
                  lodgingSelection: {
                    placeId: "ChIJ8R5RCzaNyoARegi3rqVkstk",
                    searchTerm: "Springdale, UT, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Overseas national parks",
              leafNodes: [
                {
                  label: "Fiordland National Park",
                  lodgingSelection: {
                    placeId: "ChIJa15mlSBt1KkRULR5hIbvAAU",
                    searchTerm: "Te Anau, New Zealand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kruger National Park",
                  lodgingSelection: {
                    placeId: "ChIJ1Uoupb0B6B4RRHbfYHlpTF0",
                    searchTerm: "Skukuza, South Africa",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Serengeti National Park",
                  lodgingSelection: {
                    placeId: "ChIJUV3SGQ88LRgRdXHAEqAeILE",
                    searchTerm: "Serengeti, Tanzania",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Masai Mara National Reserve",
                  lodgingSelection: {
                    placeId: "ChIJsf0xSqboLBgREMTD4IeVaik",
                    searchTerm: "Masái Mara, Kenya",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Galápagos National Park",
                  lodgingSelection: {
                    placeId: "ChIJa7-U-0NdqpoRNWGGLDX6QZg",
                    searchTerm: "Puerto Ayora, Ecuador",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Iguazú National Park",
                  lodgingSelection: {
                    placeId: "ChIJGZGd60Hq9pQRosCdl07XuCo",
                    searchTerm: "Puerto Iguazú, Misiones Province, Argentina",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cinque Terre National Park",
                  lodgingSelection: {
                    placeId: "ChIJB4uscYn61BIRgGX4h7QPnhE",
                    searchTerm: "Riomaggiore, SP, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Manuel Antonio National Park",
                  lodgingSelection: {
                    placeId: "ChIJS_Wpm5xxoY8Rhkpczjlh5pU",
                    searchTerm:
                      "Manuel Antonio National Park, Puntarenas Province, Quepos, Costa Rica",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Northern lights & the Arctic",
              leafNodes: [
                {
                  label: "Reykjavík",
                  lodgingSelection: {
                    placeId: "ChIJw-3c7rl01kgRcWDSMKIskew",
                    searchTerm: "Reykjavík, Iceland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tromso",
                  lodgingSelection: {
                    placeId: "ChIJ_XE7bFLExEUR075ujoXKPQI",
                    searchTerm: "Tromsø, Norway",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rovaniemi",
                  lodgingSelection: {
                    placeId: "ChIJUyV3dr1LK0QRxEGItK2IgBU",
                    searchTerm: "Rovaniemi, Finland",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Fairbanks",
                  lodgingSelection: {
                    placeId: "ChIJqWX9Z09FMlEROvf-CeAF2LM",
                    searchTerm: "Fairbanks, AK, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Yellowknife",
                  lodgingSelection: {
                    placeId: "ChIJyYJGoyzx0VMRge9xQyQ3wbQ",
                    searchTerm: "Yellowknife, NT, Canada",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Cultural immersions",
      imageUrl: "",
      sections: [
        {
          subsections: [
            {
              label: "Wine country",
              leafNodes: [
                {
                  label: "Napa Valley",
                  lodgingSelection: {
                    placeId: "ChIJfRoJQE1VhIARTB6YA4IIzN0",
                    searchTerm: "Yountville, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Sonoma",
                  lodgingSelection: {
                    placeId: "ChIJd517gUOshYARReDmDiHtgAM",
                    searchTerm: "Sonoma, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tuscany",
                  lodgingSelection: {
                    placeId: "ChIJrdbSgKZWKhMRAyrH7xd51ZM",
                    searchTerm:
                      "Florence, Metropolitan City of Florence, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bordeaux",
                  lodgingSelection: {
                    placeId: "ChIJgcpR9-gnVQ0RiXo5ewOGY3k",
                    searchTerm: "Bordeaux, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Porto",
                  lodgingSelection: {
                    placeId: "ChIJwVPhxKtlJA0RvBSxQFbZSKY",
                    searchTerm: "Porto, Portugal",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Mendoza",
                  lodgingSelection: {
                    placeId: "ChIJv3lRxD4JfpYROvoO0vZ4WiA",
                    searchTerm:
                      "Mendoza, Capital Department, Mendoza Province, Argentina",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rioja",
                  lodgingSelection: {
                    placeId: "ChIJOfKNL1f4Tw0R6ISKbj5MXP0",
                    searchTerm: "Laguardia, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "International food capitals",
              leafNodes: [
                {
                  label: "Tokyo",
                  lodgingSelection: {
                    placeId: "ChIJC3Cf2PuLGGAROO00ukl8JwA",
                    searchTerm:
                      "Tokyo Station, 1 Chome-9 Marunouchi, Chiyoda City, Tokyo, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Paris",
                  lodgingSelection: {
                    placeId: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                    searchTerm: "Paris, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bangkok",
                  lodgingSelection: {
                    placeId: "ChIJ82ENKDJgHTERIEjiXbIAAQE",
                    searchTerm: "Bangkok, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Lima",
                  lodgingSelection: {
                    placeId: "ChIJxz7uGfbFBZERSi5FzLlsIBQ",
                    searchTerm: "Lima, Peru",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Barcelona",
                  lodgingSelection: {
                    placeId: "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
                    searchTerm: "Barcelona, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Mexico City",
                  lodgingSelection: {
                    placeId: "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
                    searchTerm: "Mexico City, CDMX, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Rome",
                  lodgingSelection: {
                    placeId: "ChIJu46S-ZZhLxMROG5lkwZ3D7k",
                    searchTerm:
                      "Rome, Metropolitan City of Rome Capital, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Ancient wonders & historic sites",
              leafNodes: [
                {
                  label: "Machu Picchu",
                  lodgingSelection: {
                    placeId: "ChIJVVVViV-abZERJxqgpA43EDo",
                    searchTerm: "Machu Picchu, Peru",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Chichen Itza",
                  lodgingSelection: {
                    placeId: "ChIJ9_O-e9oKUY8RMao55Y8feu0",
                    searchTerm: "Valladolid, Yucatan, Mexico",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Cairo",
                  lodgingSelection: {
                    placeId: "ChIJ674hC6Y_WBQRujtC6Jay33k",
                    searchTerm: "Cairo, Egypt",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Luxor",
                  lodgingSelection: {
                    placeId: "ChIJzZXNUs8VSRQRlg4ciyvd9eA",
                    searchTerm: "Luxor, Luxor City, Luxor, Egypt",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Petra",
                  lodgingSelection: {
                    placeId: "ChIJsbYaAjBpARURueCjw3tpOuQ",
                    searchTerm: "Wadi Musa, Jordan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Beijing",
                  lodgingSelection: {
                    placeId: "ChIJuSwU55ZS8DURiqkPryBWYrk",
                    searchTerm: "Beijing, China",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "European art & history",
              leafNodes: [
                {
                  label: "Florence",
                  lodgingSelection: {
                    placeId: "ChIJrdbSgKZWKhMRAyrH7xd51ZM",
                    searchTerm:
                      "Florence, Metropolitan City of Florence, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Venice",
                  lodgingSelection: {
                    placeId: "ChIJiT3W8dqxfkcRLxCSvfDGo3s",
                    searchTerm: "Venice, Metropolitan City of Venice, Italy",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Edinburgh",
                  lodgingSelection: {
                    placeId: "ChIJIyaYpQC4h0gRJxfnfHsU8mQ",
                    searchTerm: "Edinburgh, UK",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Madrid",
                  lodgingSelection: {
                    placeId: "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",
                    searchTerm: "Madrid, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Munich",
                  lodgingSelection: {
                    placeId: "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",
                    searchTerm: "Munich, Germany",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Athens",
                  lodgingSelection: {
                    placeId: "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
                    searchTerm: "Athens, Greece",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Asian temples & heritage",
              leafNodes: [
                {
                  label: "Angkor Wat",
                  lodgingSelection: {
                    placeId: "ChIJeaiRjJoWEDER-rvlPvmqQKk",
                    searchTerm: "Siem Reap, Cambodia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kyoto",
                  lodgingSelection: {
                    placeId: "ChIJ8cM8zdaoAWARPR27azYdlsA",
                    searchTerm: "Kyoto, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Hanoi",
                  lodgingSelection: {
                    placeId: "ChIJoRyG2ZurNTERqRfKcnt_iOc",
                    searchTerm: "Hanoi, Vietnam",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Bali",
                  lodgingSelection: {
                    placeId: "ChIJN3P2zJlG0i0RACx9yvsLAwQ",
                    searchTerm: "Kuta, Badung Regency, Bali, Indonesia",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Chiang Mai",
                  lodgingSelection: {
                    placeId: "ChIJQXiZwsjM0DAR1AMlknbhaWo",
                    searchTerm: "Chiang Mai, Thailand",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Kathmandu",
                  lodgingSelection: {
                    placeId: "ChIJv6p7MIoZ6zkR6rGN8Rt8E7U",
                    searchTerm: "Kathmandu, Nepal",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Entertainment",
      imageUrl: "",
      sections: [
        {
          subsections: [
            {
              label: "Nightlife",
              leafNodes: [
                {
                  label: "Las Vegas",
                  lodgingSelection: {
                    placeId: "ChIJ0X31pIK3voARo3mz1ebVzDo",
                    searchTerm: "Las Vegas, NV, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Atlantic City",
                  lodgingSelection: {
                    placeId: "ChIJIcdcblfdwIkRYlJn6UPLb0o",
                    searchTerm: "Atlantic City, NJ, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Reno",
                  lodgingSelection: {
                    placeId: "ChIJnaCSkq5AmYARh_c4dM7FxUA",
                    searchTerm: "Reno, NV, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Macao",
                  lodgingSelection: {
                    placeId: "ChIJuclC2eB6ATQRKfm95zZJb7s",
                    searchTerm: "Macau Island, Macao",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Ibiza",
                  lodgingSelection: {
                    placeId: "ChIJhRmdbbxGmRIRiPpXk_IayrY",
                    searchTerm: "Ibiza, Spain",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Music & festivals",
              leafNodes: [
                {
                  label: "New Orleans",
                  lodgingSelection: {
                    placeId: "ChIJZYIRslSkIIYRtNMiXuhbBts",
                    searchTerm: "New Orleans, LA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Nashville",
                  lodgingSelection: {
                    placeId: "ChIJPZDrEzLsZIgRoNrpodC5P30",
                    searchTerm: "Nashville, TN, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Austin",
                  lodgingSelection: {
                    placeId: "ChIJLwPMoJm1RIYRetVp1EtGm10",
                    searchTerm: "Austin, TX, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Memphis",
                  lodgingSelection: {
                    placeId: "ChIJRZdD6h5-1YcR_rYaYBXzk9E",
                    searchTerm: "Memphis, TN, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
        {
          subsections: [
            {
              label: "Theme parks",
              leafNodes: [
                {
                  label: "Orlando",
                  lodgingSelection: {
                    placeId: "ChIJd7zN_thz54gRnr-lPAaywwo",
                    searchTerm: "Orlando, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tampa",
                  lodgingSelection: {
                    placeId: "ChIJ4dG5s4K3wogRY7SWr4kTX6c",
                    searchTerm: "Tampa, FL, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Anaheim",
                  lodgingSelection: {
                    placeId: "ChIJZ-hVgPnW3IARYLErmquJqwE",
                    searchTerm: "Anaheim, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Tokyo",
                  lodgingSelection: {
                    placeId: "ChIJC3Cf2PuLGGAROO00ukl8JwA",
                    searchTerm:
                      "Tokyo Station, 1 Chome-9 Marunouchi, Chiyoda City, Tokyo, Japan",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "Paris",
                  lodgingSelection: {
                    placeId: "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
                    searchTerm: "Paris, France",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
                {
                  label: "San Diego",
                  lodgingSelection: {
                    placeId: "ChIJSx6SrQ9T2YARed8V_f0hOg0",
                    searchTerm: "San Diego, CA, USA",
                    placeTypes: ["city", "region", "country"],
                    LodgingSelection: LodgingSelectionEnum.Place,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ];
